import store from '@/store';
import { config } from '@/config.js';
import { useQueryList as useListQuery } from '@/composables/common/useQueryList';

export function useCategoriasInforme() {
    const list = useListQuery({
        fetcher: async params => {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.categorias.index'),
                params
            );
            return res.data || { data: [], meta: {} };
        },
    });

    return {
        categorias: list.data,
        loading: list.loading,
        filters: list.filters,
        meta: list.meta,
        fetch: list.fetch,
    };
}
